import background from '@/assets/images/main-bg.jpeg';
import Button from '@/components/Button';
import { useTranslation } from 'react-i18next';

export const Hero = ({ servicesRef, contactRef }: { servicesRef: React.RefObject<HTMLElement>, contactRef: React.RefObject<HTMLElement> }) => {
  const { t } = useTranslation();

  const scrollToServices = () => {
    servicesRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  const scrollToContact = () => {
    contactRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section 
      id="hero" 
      style={style.heroContainer} 
      className='h-screen relative flex flex-col justify-center items-center px-6 md:px-[90px]'
    >
      {/* Dark overlay for opacity */}
      <div style={style.overlay} className="absolute inset-0"></div>
      
      <div className="text-center md:flex md:flex-col md:gap-0 gap-8 z-10 relative">
        <h1 className='text-white md:text-[60px]'>{t('hero.title')}</h1>
        <p className='text-white md:text-[25px] mb-28'>{t('hero.subtitle')}</p>
        <div className='flex flex-col md:flex-row gap-6 my-4 justify-center'>
          <Button
            text={t('hero.bookService')}
            onClick={scrollToServices}
            active={true}
            className='bg-primary-blue'
          />
          <Button
            text={t('hero.contactUs')}
            onClick={scrollToContact}
          />
        </div>
      </div>
    </section>
  )
}


const style = {
  heroContainer: {
    backgroundImage: `url(${background})`,
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center"
  },
  overlay: {
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    backdropFilter: "blur(0.5px)",
    position: "absolute" as const,
    top: 0,
    left: 0,
    right: 0,
    bottom: 0
  }
}
